var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTabSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home_01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA98C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PC\\u5207\\u56FE",
    transform: "translate(-33.000000, -106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(33.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,25 C19.8512746,25 25,19.8512746 25,13.5 C25,7.14872538 19.8512746,2 13.5,2 C7.14872538,2 2,7.14872538 2,13.5 C2,15.073038 2.31583219,16.5723095 2.88754349,17.9378613 C3.13929263,18.5391727 3.01561889,22.8206752 3.62073765,23.4225978 C4.2099763,24.0087241 8.47546922,23.8685633 9.08799349,24.1232438 C10.4466062,24.6881394 11.9368836,25 13.5,25 Z",
    id: "Oval-14",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8461538,16.1538462 C10.8461538,17.6195249 12.0343212,18.8076923 13.5,18.8076923 C14.9656788,18.8076923 16.1538462,17.6195249 16.1538462,16.1538462",
    id: "Oval-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.804848,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-6",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTabSelected);
export default __webpack_public_path__ + "static/media/HomeTabSelected.8e91a7a43f69fb748410782eaf03e84a.svg";
export { ForwardRef as ReactComponent };